<template>
  <el-popover width="350" trigger="hover" :append-to-body="true">
    <div class="goods-wrap">
      <div
        class="goods-wrap-title"
        v-if="row.orderItems.filter(i => [0, 1, 2, 5].includes(i.fulfillmentStatus)).length > 0"
      >
        {{ $t('stores::order::wait') }}
      </div>
      <div class="goods-wrap-list">
        <template v-for="(item, index) in row.orderItems.filter(i => [0, 1, 2, 5].includes(i.fulfillmentStatus))">
          <div class="goods-wrap-item" :key="item.id" v-if="index === 0">
            <div style="position: relative">
              <el-badge :value="row.noDeliverQuantity" type="info">
                <el-image style="width: 50px; height: 50px" :src="item.imageUrl"></el-image>
              </el-badge>
            </div>
            <div class="goods-item-info">
              <p class="more-line">{{ item.title }}</p>
              <p>{{ item.variantOptionValue }}{{ filterVariant(item.variantCustomizedOption) }}</p>
              <p>SKU {{ $dataCheck(item.skuId) }}</p>
            </div>
          </div>
        </template>
      </div>
      <div class="goods-wrap-title" v-if="row.orderItems.filter(i => i.fulfillmentStatus >= 2).length > 0">
        {{ $t('stores::order::shipping') }}
      </div>
      <div class="goods-wrap-list">
        <template v-for="(item, index) in row.orderItems.filter(i => i.fulfillmentStatus >= 2)">
          <div class="goods-wrap-item" :key="item.id" v-if="index === 0">
            <div style="position: relative">
              <el-badge :value="row.deliverQuantity" type="info">
                <el-image style="width: 50px; height: 50px" :src="item.imageUrl"></el-image>
              </el-badge>
            </div>
            <div class="goods-item-info">
              <p class="more-line">{{ $dataCheck(item.title) }}</p>
              <p>{{ item.variantOptionValue }}{{ filterVariant(item.variantCustomizedOption) }}</p>
              <p>SKU {{ $dataCheck(item.skuId) }}</p>
            </div>
          </div>
        </template>
      </div>
    </div>
    <el-button style="padding: 5px" v-show="row.orderNo === activeRow" slot="reference">
      ...
    </el-button>
  </el-popover>
</template>

<script>
import { filterVariant } from '@/utils/utils'
export default {
  name: 'order-goods',
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    activeRow: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      wait: 0,
      deliver: 0
    }
  },
  mounted() {
    this.row.orderItems &&
      this.row.orderItems
        .filter(i => i.fulfillmentStatus === 1 || i.fulfillmentStatus === 0)
        .forEach(item => {
          this.wait += item.quantity
        })
    this.row.orderItems &&
      this.row.orderItems
        .filter(i => i.fulfillmentStatus >= 2)
        .forEach(item => {
          this.deliver += item.quantity
        })
  },
  methods: {
    filterVariant
  }
}
</script>

<style lang="scss" scoped>
.goods-wrap {
  .goods-wrap-title {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .goods-wrap-item {
    display: flex;
    .goods-item-info {
      margin-left: 20px;
    }
  }
}
</style>
